import { render, staticRenderFns } from "./FormMode.vue?vue&type=template&id=31240a64&"
import script from "./FormMode.vue?vue&type=script&lang=js&"
export * from "./FormMode.vue?vue&type=script&lang=js&"
import style0 from "./FormMode.vue?vue&type=style&index=0&id=31240a64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports